import axios from 'axios';

// URL base dell'API per gli allegati progetto, recuperato dall'env file
const ALLEGATO_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'allegato-progetto';

const headers = {
    'Content-Type': 'multipart/form-data'
}

class AllegatoProgettoService {
    /**
     * Salva uno o più allegati nel sistema.
     * Effettua una chiamata POST a `/allegato-progetto/save` con i dati degli allegati.
     * 
     * @param {Object} allegati -Oggetto contenente i file da salvare.
     * @returns {Promise} - Una promessa che restituisca la risposta del server.
     */
    salvaAllegati(allegati) {
        return axios.post(ALLEGATO_REST_API_URL + "/save", allegati, { headers });
    }
    
    /**
     * Elimina allegati specifici in base ai loro ID.
     * Effettua una richiesta POST a `/allegato-progetto/delete-by-id` con un array di ID da eliminare.
     *
     * @param {Array<number>} allegatiIds - Lista degli ID degli allegati da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server.
    */
    eliminaAllegatiById(allegatiIds) {
        return axios.post(ALLEGATO_REST_API_URL + "/delete-by-id", allegatiIds, { "Content-Type": "application/json" });
    }

    /**
     * Recupera tutti gli allegati associati a un determinato progetto.
     * Effettua una richiesta GET a `/allegato-progetto/find-by-prog-id/{progId}`.
     *
     * @param {number} progId - ID del progetto per cui recuperare gli allegati.
     * @returns {Promise} - Una promessa che restituisce la lista degli allegati.
     */
    getAllegatiByProgId(progId) {
        return axios.get(ALLEGATO_REST_API_URL + "/find-by-prog-id/" + progId);
    }

    /**
     * Conta il numero totale di allegati associati a un progetto.
     * Effettua una richiesta GET a `/allegato-progetto/count-allegati/{progId}`.
     *
     * @param {number} progId - ID del progetto di cui contare gli allegati.
     * @returns {Promise} - Una promessa che restituisce il conteggio degli allegati.
     */
    getCountAllegatiByProgetto(progId) {
        return axios.get(`${ALLEGATO_REST_API_URL}/count-allegati/${progId}`, { headers });
    }


}

// Creazione dell'istanza per essere importata direttamente nei componenti
const allegatoProgettoServiceInstance = new AllegatoProgettoService();
export default allegatoProgettoServiceInstance;
